const floorDecimals = (value: number, fractionDigits?: number) => {
  const floatValue = Math.floor(parseFloat(`${value}e${fractionDigits}`));
  return Number(`${floatValue}e-${fractionDigits}`);
};

export default floorDecimals;
